import { inject as injectBranding } from '@angular/core';
import { SiteBrandingService } from '../../services/site-branding.service';
import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PageHero, PageHeroService } from '../../services/page-hero.service';

@Component({
  selector: 'app-hero',
  imports: [RouterModule],
  templateUrl: './hero.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./hero.component.css']
})
export class HeroComponent implements OnInit {
  readonly branding = injectBranding(SiteBrandingService);
  hero: PageHero | null = null;

  constructor(private readonly pageHeroService: PageHeroService) {}

  ngOnInit(): void {
    this.pageHeroService.getHero('home').subscribe({
      next: hero => {
        this.hero = hero;
      },
      error: error => {
        console.error('Failed to load home hero.', error);
      }
    });
  }

  startHeroVideo(video: HTMLVideoElement): void {
    video.muted = true;
    video.defaultMuted = true;

    void video.play().catch(error => {
      console.warn('Hero video autoplay was blocked.', error);
    });
  }

  get mediaUrl(): string | null {
    return this.pageHeroService.getMediaUrl(
      this.hero?.mediaAssetId ?? null
    );
  }

  get fallbackMediaUrl(): string | null {
    return this.pageHeroService.getMediaUrl(
      this.hero?.fallbackMediaAssetId ?? null
    );
  }

  get isVideo(): boolean {
    return this.hero?.backgroundType === 'Video';
  }

  get isImage(): boolean {
    return this.hero?.backgroundType === 'Image';
  }
}
